<ng-container *transloco="let t">
  <mat-stepper [linear]="true" #stepper>
    <mat-step>
      <ng-template matStepLabel>{{ t(selectedCategoryLabel) }}</ng-template>
      <mat-progress-bar mode="determinate" [value]="25"></mat-progress-bar>
      <div class="search-container">
        <mat-form-field appearance="outline" class="search-field hidden-error">
          <input
            matInput
            [value]="searchQuery"
            (input)="searchQuery = $any($event.target).value; cd.markForCheck()"
            [placeholder]="t('Search forms by name...')"
            [attr.aria-label]="t('Search forms by name...')"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      @if (searchQuery.trim().length > 0) {
        <div class="cards-container content !pb-4">
          @for (form of searchResults; track form.id) {
            <div class="card-wrapper">
              <mat-card
                class="card cursor"
                (click)="
                  form.id === 'zahtev-vetlab'
                    ? downloadZahtevVetLab()
                    : form.id === 'zahtev-seqomics'
                      ? downloadZahtevSeqoMics()
                      : form.id === 'zahtev-titar-paster'
                        ? downloadZahtevTitarPaster()
                        : form.id === 'prot-24h-protokol'
                          ? download24hProtocol()
                          : form.id === 'prot-visednevni'
                            ? downloadVisednevniProtocol()
                            : form.id === 'prot-anestezije'
                              ? downloadAnesthesiaProtocol()
                              : form.id === 'prot-dirofilarioze'
                                ? downloadDirofilariozeProtocol()
                                : form.id === 'prot-infuzije'
                                  ? downloadInfusionProtocol()
                                  : form.id ===
                                      'preoperativna-priprema-pacijenta'
                                    ? selectFormByDefinition(form, stepper)
                                    : form.id === 'postoperativna-nega'
                                      ? selectFormByDefinition(form, stepper)
                                      : form.id ===
                                          'upustvo-nege-posle-carskog-reza'
                                        ? selectFormByDefinition(form, stepper)
                                        : form.id === 'uputstvo-za-putovanje'
                                          ? selectFormByDefinition(
                                              form,
                                              stepper
                                            )
                                          : form.id ===
                                              'instrukcije-elizabetina-kragna'
                                            ? selectFormByDefinition(
                                                form,
                                                stepper
                                              )
                                            : form.id ===
                                                'program-vakcinacije-pasa'
                                              ? openDogVaccinationProgram()
                                              : form.id ===
                                                  'program-vakcinacije-macaka'
                                                ? openCatVaccinationProgram()
                                                : form.id === 'dental-record'
                                                  ? downloadDentalRecord()
                                                  : form.id ===
                                                      'nalaz-neuroloski'
                                                    ? downloadNalazNeuroloski()
                                                    : form.id ===
                                                        'nalaz-echo-srca-macke'
                                                      ? downloadNalazEchoMacke()
                                                      : form.id ===
                                                          'nalaz-echo-srca-psa'
                                                        ? downloadNalazEchoPsa()
                                                        : form.id ===
                                                            'nalaz-ekg'
                                                          ? downloadNalazEkg()
                                                          : form.id ===
                                                              'endoskopski-nalaz'
                                                            ? downloadEndoskopski()
                                                            : form.id ===
                                                                'pregled-oka'
                                                              ? downloadPregledOka()
                                                              : selectFormFromSearch(
                                                                  form,
                                                                  stepper
                                                                )
                "
              >
                <div class="card-content">
                  <mat-icon class="file-text-icon"></mat-icon>
                  <span class="text">{{ t(form.name) }}</span>
                </div>
                <span class="category-badge">{{ t(form.category ?? '') }}</span>
              </mat-card>
            </div>
          }
          @if (searchResults.length === 0) {
            <p class="no-results">{{ t('No forms found') }}</p>
          }
        </div>
      } @else {
        <div class="cards-container content !pb-4">
          @for (cat of categories; track cat.key; let i = $index) {
            <div class="card-wrapper">
              <mat-card
                class="card cursor"
                (click)="selectCategory(cat.key, stepper)"
              >
                <div class="card-content">
                  <mat-icon class="file-text-icon"></mat-icon>
                  <span class="text">{{ t(cat.label) }}</span>
                </div>
              </mat-card>
            </div>
          }
        </div>
      }
      <!-- end @else -->
      <mat-dialog-actions align="end">
        <button
          mat-stroked-button
          (click)="closeDialog()"
          class="secondary-btn"
        >
          {{ t('Close') }}
        </button>
      </mat-dialog-actions>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>{{ t(selectedFormLabel) }}</ng-template>
      <mat-progress-bar mode="determinate" [value]="50"></mat-progress-bar>
      <div class="cards-container content !pb-4">
        @for (form of filteredForms; track form.id; let i = $index) {
          <div class="card-wrapper">
            @if (
              (form.id !== 'zahtev-vetlab' && form.id !== 'zahtev-seqomics') ||
              isSerbianLang
            ) {
              <mat-card
                class="card cursor"
                (click)="
                  form.id === 'zahtev-vetlab'
                    ? downloadZahtevVetLab()
                    : form.id === 'zahtev-seqomics'
                      ? downloadZahtevSeqoMics()
                      : form.id === 'zahtev-titar-paster'
                        ? downloadZahtevTitarPaster()
                        : form.id === 'prot-24h-protokol'
                          ? download24hProtocol()
                          : form.id === 'prot-visednevni'
                            ? downloadVisednevniProtocol()
                            : form.id === 'prot-anestezije'
                              ? downloadAnesthesiaProtocol()
                              : form.id === 'prot-dirofilarioze'
                                ? downloadDirofilariozeProtocol()
                                : form.id === 'prot-infuzije'
                                  ? downloadInfusionProtocol()
                                  : form.id ===
                                      'preoperativna-priprema-pacijenta'
                                    ? selectFormByDefinition(form, stepper)
                                    : form.id === 'postoperativna-nega'
                                      ? selectFormByDefinition(form, stepper)
                                      : form.id ===
                                          'upustvo-nege-posle-carskog-reza'
                                        ? selectFormByDefinition(form, stepper)
                                        : form.id === 'uputstvo-za-putovanje'
                                          ? selectFormByDefinition(
                                              form,
                                              stepper
                                            )
                                          : form.id ===
                                              'instrukcije-elizabetina-kragna'
                                            ? selectFormByDefinition(
                                                form,
                                                stepper
                                              )
                                            : form.id ===
                                                'program-vakcinacije-pasa'
                                              ? openDogVaccinationProgram()
                                              : form.id ===
                                                  'program-vakcinacije-macaka'
                                                ? openCatVaccinationProgram()
                                                : form.id === 'dental-record'
                                                  ? downloadDentalRecord()
                                                  : form.id ===
                                                      'nalaz-neuroloski'
                                                    ? downloadNalazNeuroloski()
                                                    : form.id ===
                                                        'nalaz-echo-srca-macke'
                                                      ? downloadNalazEchoMacke()
                                                      : form.id ===
                                                          'nalaz-echo-srca-psa'
                                                        ? downloadNalazEchoPsa()
                                                        : form.id ===
                                                            'nalaz-ekg'
                                                          ? downloadNalazEkg()
                                                          : form.id ===
                                                              'endoskopski-nalaz'
                                                            ? downloadEndoskopski()
                                                            : form.id ===
                                                                'pregled-oka'
                                                              ? downloadPregledOka()
                                                              : selectFormByDefinition(
                                                                  form,
                                                                  stepper
                                                                )
                "
              >
                <div class="justify-content-space-between">
                  <div class="card-content">
                    <mat-icon class="file-text-icon"></mat-icon>
                    <span class="text">{{ t(form.name) }}</span>
                  </div>

                  <button
                    class="background-transparent"
                    mat-icon-button
                    (click)="
                      $event.stopPropagation();
                      form.id === 'zahtev-vetlab'
                        ? downloadZahtevVetLab()
                        : form.id === 'zahtev-seqomics'
                          ? downloadZahtevSeqoMics()
                          : form.id === 'zahtev-titar-paster'
                            ? downloadZahtevTitarPaster()
                            : form.id === 'prot-24h-protokol'
                              ? download24hProtocol()
                              : form.id === 'prot-visednevni'
                                ? downloadVisednevniProtocol()
                                : form.id === 'prot-anestezije'
                                  ? downloadAnesthesiaProtocol()
                                  : form.id === 'prot-dirofilarioze'
                                    ? downloadDirofilariozeProtocol()
                                    : form.id === 'prot-infuzije'
                                      ? downloadInfusionProtocol()
                                      : form.id ===
                                          'preoperativna-priprema-pacijenta'
                                        ? openPreopInstruction()
                                        : form.id === 'postoperativna-nega'
                                          ? selectFormByDefinition(
                                              form,
                                              stepper
                                            )
                                          : form.id ===
                                              'upustvo-nege-posle-carskog-reza'
                                            ? selectFormByDefinition(
                                                form,
                                                stepper
                                              )
                                            : form.id ===
                                                'uputstvo-za-putovanje'
                                              ? selectFormByDefinition(
                                                  form,
                                                  stepper
                                                )
                                              : form.id ===
                                                  'instrukcije-elizabetina-kragna'
                                                ? selectFormByDefinition(
                                                    form,
                                                    stepper
                                                  )
                                                : form.id ===
                                                    'program-vakcinacije-pasa'
                                                  ? openDogVaccinationProgram()
                                                  : form.id ===
                                                      'program-vakcinacije-macaka'
                                                    ? openCatVaccinationProgram()
                                                    : form.id ===
                                                        'dental-record'
                                                      ? downloadDentalRecord()
                                                      : form.id ===
                                                          'nalaz-neuroloski'
                                                        ? downloadNalazNeuroloski()
                                                        : form.id ===
                                                            'nalaz-echo-srca-macke'
                                                          ? downloadNalazEchoMacke()
                                                          : form.id ===
                                                              'nalaz-echo-srca-psa'
                                                            ? downloadNalazEchoPsa()
                                                            : form.id ===
                                                                'nalaz-ekg'
                                                              ? downloadNalazEkg()
                                                              : form.id ===
                                                                  'endoskopski-nalaz'
                                                                ? downloadEndoskopski()
                                                                : form.id ===
                                                                    'pregled-oka'
                                                                  ? downloadPregledOka()
                                                                  : selectFormByDefinition(
                                                                      form,
                                                                      stepper
                                                                    )
                    "
                    aria-label="Icon button"
                  >
                    <mat-icon
                      class="preview-icon"
                      style="width: 20px; height: 20px"
                    ></mat-icon>
                  </button>
                </div>
              </mat-card>
            }
          </div>
        }
      </div>
      <mat-dialog-actions align="end">
        <button
          mat-stroked-button
          matStepperPrevious
          class="secondary-btn"
          (click)="selectedCategory = null; selectedFormIndex = null"
        >
          {{ t('Back') }}
        </button>
        <button
          mat-stroked-button
          (click)="closeDialog()"
          class="secondary-btn"
        >
          {{ t('Close') }}
        </button>
      </mat-dialog-actions>
    </mat-step>

    <mat-step [stepControl]="currentFormGroup">
      <ng-template matStepLabel>{{ t('Fill Form') }}</ng-template>
      <mat-progress-bar mode="determinate" [value]="100"></mat-progress-bar>
      <form [formGroup]="currentFormGroup" class="pt-2">
        <div class="form-wrapper">
          <!-- Special-case complex components keep their original UX -->
          @if (forms[currentFormIndex]?.name === 'Dental Record') {
            <div>
              @if (data.speciesName === 'pas') {
                <anihis-dental-record
                  (formChange)="handleFormChange($event)"
                ></anihis-dental-record>
              } @else {
                <ng-template #noData>{{ t('No data') }}</ng-template>
              }
            </div>
          }
          @if (
            forms[currentFormIndex]?.name ===
            'Clinical Observation of Dog for Rabies'
          ) {
            <div>
              <anihis-clinic-observation-dog-rabies
                (formChange)="handleFormChange($event)"
              ></anihis-clinic-observation-dog-rabies>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id === 'owner-statement-ownership-change'
          ) {
            <div>
              <anihis-owner-statement-ownership-change
                (formChange)="handleFormChange($event)"
              ></anihis-owner-statement-ownership-change>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id === 'procedure-under-general-anesthesia'
          ) {
            <div>
              <anihis-procedure-under-general-anesthesia
                (formChange)="handleFormChange($event)"
              ></anihis-procedure-under-general-anesthesia>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id ===
            'owner-statement-treatment-procedure'
          ) {
            <div>
              <anihis-owner-statement-treatment-procedure
                (formChange)="handleFormChange($event)"
              ></anihis-owner-statement-treatment-procedure>
            </div>
          }
          @if (
            forms[currentFormIndex]?.name === 'Clinical Examination Report'
          ) {
            <div>
              <anihis-clinical-examination-report
                (formChange)="handleFormChange($event)"
              ></anihis-clinical-examination-report>
            </div>
          }
          @if (forms[currentFormIndex]?.name === 'Sterilization Certificate') {
            <div>
              <anihis-potvrda-sterilizacije
                (formChange)="handleFormChange($event)"
              ></anihis-potvrda-sterilizacije>
            </div>
          }
          @if (
            forms[currentFormIndex]?.name?.includes('Discharge with Epicrisis')
          ) {
            <div>
              <anihis-discharge-epicrisis
                (formChange)="handleFormChange($event)"
              ></anihis-discharge-epicrisis>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id === 'clinical-examination-certificate'
          ) {
            <div>
              <anihis-clinical-examination-certificate
                (formChange)="handleFormChange($event)"
              ></anihis-clinical-examination-certificate>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'certificate-origin-health') {
            <div>
              <anihis-certificate-origin-health
                (formChange)="handleFormChange($event)"
              ></anihis-certificate-origin-health>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id === 'rabies-examination-certificate'
          ) {
            <div>
              <anihis-rabies-examination-certificate
                (formChange)="handleFormChange($event)"
              ></anihis-rabies-examination-certificate>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'bandages-maintenance') {
            <div>
              <anihis-bandages-maintenance
                (formChange)="handleFormChange($event)"
              ></anihis-bandages-maintenance>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'durogesic-patch-instructions') {
            <div>
              <anihis-durogesic-patch-instructions
                (formChange)="handleFormChange($event)"
              ></anihis-durogesic-patch-instructions>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'potvrda-blanko') {
            <div>
              <anihis-potvrda-blanko
                (formChange)="handleFormChange($event)"
              ></anihis-potvrda-blanko>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id === 'rabies-vaccination-certificate'
          ) {
            <div>
              <anihis-rabies-vaccination-certificate
                [animalData]="data"
                (formChange)="handleFormChange($event)"
              ></anihis-rabies-vaccination-certificate>
            </div>
          }

          <!-- Anamnestic Card: render grouped inputs using the currentFormGroup -->
          @if (forms[currentFormIndex]?.id === 'anamnesticki-karton') {
            <div>
              @for (g of forms[currentFormIndex]?.groups; track g) {
                <div class="group-block" [formGroupName]="g.groupName">
                  <h3 class="group-title">
                    {{ t(g.groupName) || g.groupName }}
                  </h3>
                  <div class="group-inputs">
                    @for (inp of g.inputs; track inp) {
                      <mat-form-field appearance="outline" class="w-full mb-3">
                        <mat-label>{{
                          t(anamnesisLabelMap[inp.formControlName])
                        }}</mat-label>
                        @if (inp.type === 'textbox') {
                          <textarea
                            appAutofocus
                            matInput
                            [formControlName]="inp.formControlName"
                            rows="3"
                          ></textarea>
                        }
                        @if (inp.formControlName === 'nutrition') {
                          <mat-select [formControlName]="inp.formControlName">
                            <mat-option [value]="t('Commercial food')">{{
                              t('Commercial food')
                            }}</mat-option>
                            <mat-option [value]="t('Home prepared')">{{
                              t('Home prepared')
                            }}</mat-option>
                            <mat-option [value]="t('Mixed diet')">{{
                              t('Mixed diet')
                            }}</mat-option>
                          </mat-select>
                        }
                        @if (
                          inp.type !== 'textbox' &&
                          inp.formControlName !== 'nutrition'
                        ) {
                          <input
                            matInput
                            [formControlName]="inp.formControlName"
                          />
                        }
                      </mat-form-field>
                    }
                  </div>
                </div>
              }
            </div>
          }
          @if (
            forms[currentFormIndex]?.name === 'Referral for histopathology'
          ) {
            <div>
              <anihis-referral-for-histopathology
                (formChange)="handleFormChange($event)"
              ></anihis-referral-for-histopathology>
            </div>
          }
          @if (
            forms[currentFormIndex]?.name ===
            'Cardio-Pulmonary Dirofilariasis (Heartworm Disease) Treatment Record'
          ) {
            <div>
              <anihis-cardio-pulmonary-dirofilariasis
                (formChange)="handleFormChange($event)"
              ></anihis-cardio-pulmonary-dirofilariasis>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'prot-hemoterapije') {
            <div>
              <anihis-chemotherapy-protocol
                (formChange)="handleFormChange($event)"
              ></anihis-chemotherapy-protocol>
            </div>
          }
          @if (forms[currentFormIndex]?.name === 'Request for examination') {
            <div>
              <anihis-instruction-for-examination
                (formChange)="handleFormChange($event)"
              ></anihis-instruction-for-examination>
            </div>
          }
          @if (forms[currentFormIndex]?.name === 'Antibiogram Certificate') {
            <div>
              <anihis-potvrde-antibiogram
                (formChange)="handleFormChange($event)"
              ></anihis-potvrde-antibiogram>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'lab-biohemija-results') {
            <div>
              <anihis-lab-biohemija-dog
                (formChange)="handleFormChange($event)"
              ></anihis-lab-biohemija-dog>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'result-trio-dog') {
            <div>
              <anihis-result-trio-dog
                (formChange)="handleFormChange($event)"
              ></anihis-result-trio-dog>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'cpv-ccv-finding') {
            <div>
              <anihis-cpv-ccv-finding
                (formChange)="handleFormChange($event)"
              ></anihis-cpv-ccv-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'result-trio-cat') {
            <div>
              <anihis-result-trio-cat
                (formChange)="handleFormChange($event)"
              ></anihis-result-trio-cat>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'ultrasound-finding') {
            <div>
              <anihis-ultrasound-finding
                (formChange)="handleFormChange($event)"
              ></anihis-ultrasound-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'urine-finding') {
            <div>
              <anihis-urine-finding
                (formChange)="handleFormChange($event)"
              ></anihis-urine-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'spermogram-finding') {
            <div>
              <anihis-spermogram-finding
                (formChange)="handleFormChange($event)"
              ></anihis-spermogram-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'rtg-finding') {
            <div>
              <anihis-rtg-finding
                (formChange)="handleFormChange($event)"
              ></anihis-rtg-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'radiology-finding') {
            <div>
              <anihis-radiology-finding
                (formChange)="handleFormChange($event)"
              ></anihis-radiology-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'orthopedic-finding') {
            <div>
              <anihis-orthopedic-finding
                (formChange)="handleFormChange($event)"
              ></anihis-orthopedic-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'mri-finding') {
            <div>
              <anihis-mri-finding
                (formChange)="handleFormChange($event)"
              ></anihis-mri-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'leishmania-finding') {
            <div>
              <anihis-leishmania-finding
                (formChange)="handleFormChange($event)"
              ></anihis-leishmania-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'koproloski-finding') {
            <div>
              <anihis-koproloski-finding
                (formChange)="handleFormChange($event)"
              ></anihis-koproloski-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'cdv-finding') {
            <div>
              <anihis-cdv-finding
                (formChange)="handleFormChange($event)"
              ></anihis-cdv-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'baep-finding') {
            <div>
              <anihis-baep-finding
                (formChange)="handleFormChange($event)"
              ></anihis-baep-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'babesia-finding') {
            <div>
              <anihis-babesia-finding
                (formChange)="handleFormChange($event)"
              ></anihis-babesia-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'ophthalmology-report') {
            <div>
              <anihis-ophthalmology-report
                (formChange)="handleFormChange($event)"
              ></anihis-ophthalmology-report>
            </div>
          }
          @if (forms[currentFormIndex]?.name === 'VetLab Anamnesis Request') {
            <div>
              <anihis-vetlab-anamnesticki
                (formChange)="handleFormChange($event)"
              ></anihis-vetlab-anamnesticki>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'lab-hemato-bio-cat') {
            <div>
              <anihis-lab-hemato-bio-cat
                (formChange)="handleFormChange($event)"
              ></anihis-lab-hemato-bio-cat>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'lab-hemato-bio-dog') {
            <div>
              <anihis-lab-hemato-bio-dog
                (formChange)="handleFormChange($event)"
              ></anihis-lab-hemato-bio-dog>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'lab-hemato-cat') {
            <div>
              <anihis-lab-hemato-cat
                (formChange)="handleFormChange($event)"
              ></anihis-lab-hemato-cat>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'lab-hemato-dog') {
            <div>
              <anihis-lab-hemato-dog
                (formChange)="handleFormChange($event)"
              ></anihis-lab-hemato-dog>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'lab-biohemija-results-cat') {
            <div>
              <anihis-lab-biohemija-cat
                (formChange)="handleFormChange($event)"
              ></anihis-lab-biohemija-cat>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'fna-finding') {
            <div>
              <anihis-fna-finding
                (formChange)="handleFormChange($event)"
              ></anihis-fna-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'owner-statement-vaccination') {
            <div>
              <anihis-owner-statement-vaccination
                (formChange)="handleFormChange($event)"
              ></anihis-owner-statement-vaccination>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'owner-statement-new-passport') {
            <div>
              <anihis-owner-statement-new-passport
                (formChange)="handleFormChange($event)"
              ></anihis-owner-statement-new-passport>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id === 'owner-statement-deregistration'
          ) {
            <div>
              <anihis-owner-statement-deregistration
                (formChange)="handleFormChange($event)"
              ></anihis-owner-statement-deregistration>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id === 'owner-statement-debt-installments'
          ) {
            <div>
              <anihis-owner-statement-debt-installments
                (formChange)="handleFormChange($event)"
              ></anihis-owner-statement-debt-installments>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id === 'owner-statement-dental-treatment'
          ) {
            <div>
              <anihis-owner-statement-dental-treatment
                (formChange)="handleFormChange($event)"
              ></anihis-owner-statement-dental-treatment>
            </div>
          }
          @if (
            forms[currentFormIndex]?.id ===
            'owner-statement-inpatient-admission'
          ) {
            <div>
              <anihis-owner-statement-inpatient-admission
                (formChange)="handleFormChange($event)"
              ></anihis-owner-statement-inpatient-admission>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'prijemni-formular') {
            <div>
              <anihis-prijemni-formular
                (formChange)="handleFormChange($event)"
              ></anihis-prijemni-formular>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'owner-statement-euthanasia') {
            <div>
              <anihis-owner-statement-euthanasia
                (formChange)="handleFormChange($event)"
              ></anihis-owner-statement-euthanasia>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'analysis-points') {
            <div>
              <anihis-analysis-points-finding
                (formChange)="handleFormChange($event)"
              ></anihis-analysis-points-finding>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'nalaz-4d-l') {
            <div>
              <anihis-nalaz-4d-l
                (formChange)="handleFormChange($event)"
              ></anihis-nalaz-4d-l>
            </div>
          }

          @if (forms[currentFormIndex]?.id === 'fip-test-result') {
            <div>
              <anihis-fip-test
                (formChange)="handleFormChange($event)"
              ></anihis-fip-test>
            </div>
          }
          @if (forms[currentFormIndex]?.id === 'fiv-test-result') {
            <div>
              <anihis-fiv-test
                (formChange)="handleFormChange($event)"
              ></anihis-fiv-test>
            </div>
          }

          <!-- Render generic dynamic forms (inputs/groups) when no specialized component exists -->
          @if (
            !(
              forms[currentFormIndex]?.name === 'Dental Record' ||
              forms[currentFormIndex]?.name ===
                'Clinical Observation of Dog for Rabies' ||
              forms[currentFormIndex]?.name?.includes('Owner') ||
              forms[currentFormIndex]?.name === 'Clinical Examination Report' ||
              forms[currentFormIndex]?.name ===
                'Cardio-Pulmonary Dirofilariasis (Heartworm Disease) Treatment Record' ||
              forms[currentFormIndex]?.id === 'cdv-finding'
            )
          ) {
            <div>
              @if (
                !explicitComponentFormIds.includes(
                  forms[currentFormIndex]?.id || ''
                ) &&
                ((forms[currentFormIndex]?.inputs &&
                  forms[currentFormIndex]?.inputs?.length) ||
                  (forms[currentFormIndex]?.groups &&
                    forms[currentFormIndex]?.groups?.length))
              ) {
                <anihis-dynamic-form
                  [definition]="forms[currentFormIndex]"
                  [formGroup]="currentFormGroup"
                  (formChange)="handleFormChange($event)"
                ></anihis-dynamic-form>
              }
            </div>
          }
        </div>
      </form>

      <mat-dialog-actions align="end">
        <button
          mat-stroked-button
          matStepperPrevious
          class="secondary-btn"
          (click)="clearForm()"
        >
          {{ t('Back') }}
        </button>

        <button
          mat-flat-button
          class="primary-btn"
          [disabled]="isSaving() || store.status() === status.Loading"
          (click)="saveChanges()"
        >
          @if (isSaving() || store.status() === status.Loading) {
            <mat-progress-spinner
              diameter="18"
              mode="indeterminate"
              strokeWidth="3"
            ></mat-progress-spinner>
          }
          {{ t('Confirm') }}
        </button>
      </mat-dialog-actions>
    </mat-step>
  </mat-stepper>
</ng-container>
